const CA_REGIONS = [
  ['AB', 'Alberta'], ['BC', 'British Columbia'], ['MB', 'Manitoba'],
  ['NB', 'New Brunswick'], ['NL', 'Newfoundland and Labrador'],
  ['NS', 'Nova Scotia'], ['NT', 'Northwest Territories'], ['NU', 'Nunavut'],
  ['ON', 'Ontario'], ['PE', 'Prince Edward Island'], ['QC', 'Quebec'],
  ['SK', 'Saskatchewan'], ['YT', 'Yukon'],
];

const US_REGIONS = [
  ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'],
  ['CA', 'California'], ['CO', 'Colorado'], ['CT', 'Connecticut'], ['DE', 'Delaware'],
  ['DC', 'District of Columbia'], ['FL', 'Florida'], ['GA', 'Georgia'], ['HI', 'Hawaii'],
  ['ID', 'Idaho'], ['IL', 'Illinois'], ['IN', 'Indiana'], ['IA', 'Iowa'],
  ['KS', 'Kansas'], ['KY', 'Kentucky'], ['LA', 'Louisiana'], ['ME', 'Maine'],
  ['MD', 'Maryland'], ['MA', 'Massachusetts'], ['MI', 'Michigan'], ['MN', 'Minnesota'],
  ['MS', 'Mississippi'], ['MO', 'Missouri'], ['MT', 'Montana'], ['NE', 'Nebraska'],
  ['NV', 'Nevada'], ['NH', 'New Hampshire'], ['NJ', 'New Jersey'], ['NM', 'New Mexico'],
  ['NY', 'New York'], ['NC', 'North Carolina'], ['ND', 'North Dakota'], ['OH', 'Ohio'],
  ['OK', 'Oklahoma'], ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'],
  ['SC', 'South Carolina'], ['SD', 'South Dakota'], ['TN', 'Tennessee'], ['TX', 'Texas'],
  ['UT', 'Utah'], ['VT', 'Vermont'], ['VA', 'Virginia'], ['WA', 'Washington'],
  ['WV', 'West Virginia'], ['WI', 'Wisconsin'], ['WY', 'Wyoming'],
];

export const FIXED_ADDRESS_REGIONS = {
  CA: CA_REGIONS.map(([code, name]) => ({ code, name })),
  US: US_REGIONS.map(([code, name]) => ({ code, name })),
};

export function normalizeAddressCountryCode(value) {
  const text = String(value || '').trim();
  const aliases = {
    Canada: 'CA', canada: 'CA',
    'United States': 'US', 'United States of America': 'US',
    USA: 'US', usa: 'US', us: 'US',
  };
  return aliases[text] || text.toUpperCase();
}

export function fixedRegionsForCountry(value) {
  return FIXED_ADDRESS_REGIONS[normalizeAddressCountryCode(value)] || [];
}

/* Provinces and states are shown as their two-letter code throughout the
   portal, so this is what display code should call. A value we do not
   recognise is returned unchanged rather than blanked. */
export function regionDisplay(country, value) {
  return regionCode(country, value) || String(value || '').trim();
}

export function fullRegionName(country, value) {
  const text = String(value || '').trim();
  if (!text) return '';
  const normalized = text.toLowerCase();
  const match = fixedRegionsForCountry(country).find(
    (region) => region.code.toLowerCase() === normalized || region.name.toLowerCase() === normalized,
  );
  return match?.name || text;
}

export function regionCode(country, value) {
  const text = String(value || '').trim();
  if (!text) return '';
  const normalized = text.toLowerCase();
  const match = fixedRegionsForCountry(country).find(
    (region) => region.code.toLowerCase() === normalized || region.name.toLowerCase() === normalized,
  );
  return match?.code || text;
}
